import {
	ActionButtons,
	Button,
	Container,
	Content,
	ImgContainer,
	Label,
} from './Modal.styles'
import React from 'react'
import heart from 'App/assets/error-welbe.svg'

type ModalProps = {
	onCancel: () => void
	onRetry: () => void
}

export const Modal = ({ onCancel, onRetry }: ModalProps) => {
	return (
		<Container>
			<Content>
				<ImgContainer>
					<img src={heart} />
				</ImgContainer>
				<Label margin={40} type="title">
					No se pudo realizar tu pago
				</Label>
				<Label margin={20} type="paragraph">
					<div>
						Si el error persiste ponte en contacto con{' '}
						<a
							href="https://wa.me/+5215633064096"
							target="_blank"
							rel="noreferrer"
						>
							soporte
						</a>
					</div>
				</Label>
				<ActionButtons>
					<Button label onClick={onCancel}>
						Cancelar
					</Button>
					<Button onClick={onRetry}>Reintentar</Button>
				</ActionButtons>
			</Content>
		</Container>
	)
}
